import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { GradeBadge } from "@/components/Badges";
import { AlertTriangle } from "lucide-react";

export default function AuditMismatches() {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/audit/mismatches").then((r) => setItems(r.data)); }, []);
  return (
    <div>
      <div className="eyebrow">Audit</div>
      <h1 className="text-2xl font-bold" style={{ color: "var(--brand-navy)" }}>Audit Mismatches</h1>
      <p className="text-sm text-[#4A627A] mt-1">Grades assigned by the supervisor during an unannounced audit that differ from the inspector's last recorded grade on the same loom.</p>
      <div className="mt-4 space-y-2">
        {items.map((m) => (
          <div key={m.id} data-testid={`mismatch-${m.id}`} className="hag-surface p-3">
            <div className="flex items-center gap-2 flex-wrap">
              <span className="status-chip pace-amber flex items-center gap-1"><AlertTriangle size={12} /> Mismatch</span>
              <span className="font-semibold">Loom {m.loom_number}</span>
              <span className="text-xs text-[#7C8E9E]">{new Date(m.created_at).toLocaleString()}</span>
            </div>
            <div className="mt-2 flex items-center gap-3 flex-wrap text-sm">
              <div>Inspector <b>{m.inspector_name}</b>: <GradeBadge grade={m.inspector_grade} /></div>
              <div>Supervisor <b>{m.supervisor_name}</b>: <GradeBadge grade={m.supervisor_grade} /></div>
            </div>
            {m.note && <div className="mt-1 text-xs text-[#4A627A]">Note: {m.note}</div>}
          </div>
        ))}
        {items.length === 0 && <div className="text-sm text-[#7C8E9E]">No mismatches recorded yet.</div>}
      </div>
    </div>
  );
}
